export default {
  title: {
    en: 'What you’re getting...',
  },
  text: {
    en: `
      A month-to-month subscription to Scentbird. Billed monthly,
      renews automatically, and ships from our warehouse mid-month.
    `,
  },
  textGift: {
    en: `
      Because you bought a Gift Subscription for a friend, we're giving you two free months of Scentbird!
      After the free period, you will be charged $16.95 each month to continue.
    `,
  },
  arrives: {
    en: 'Arrives in {month}',
  },
  edit: {
    en: 'Edit',
  },
  case: {
    en: 'A fragrance atomizer case',
  },
  emptyProduct: {
    en: 'Your choice of one 8ml fragrance a month, with a free case included',
  },
  emptyProductMultiPlan: {
    en: '{productsPerPeriod} scents every month to fit your lifestyle, with a free case included',
  },
  firstFragrance: {
    en: 'This is your first 8ml fragrance. You can see any others and edit them, once you’ve subscribed.',
  },
  firstMultiFragrances: {
    en: 'These are your 8ml fragrances for your first delivery. You can see any others and edit them, once you’ve subscribed.',
  },
  productEmptyCell: {
    title: {
      en: 'This is your {flatIndex, select, 0 {first} 1 {second} 2 {third}} fragrance',
    },
    note: {
      en: 'If you haven’t chosen a scent, you’ll get our fragrance of the month.',
    },
  },
  upcharge: {
    label: {
      en: 'Plus {price}',
    },
    explanation: {
      title: {
        en: 'What is a premium product?',
      },
      text: {
        en: `
          Feeling fancy? Scentbird offers a limited run of super-luxe items.
          Premium products will cost an additional $5, $10, or $15 depending on the item, which you'll see reflected in
          your account should you choose to include one. <br /><br />
          When you opt for a premium product surcharge will be applied to all subscription types including referrals,
          gift cards, and limited-time offers.
        `,
      },
    },
  },
  free: {
    en: 'Free!',
  },
}
